import { ThemeUIStyleObject } from 'theme-ui';

// The different button shapes designed in Figma
export enum ButtonVariants {
  primary,
  outline,
  rounded,
  text
}

/**
 * This function will compute button colors based on a given variant and main color
 * Based on the variant, the main color can be a different CSS property (background, color or border...)
 *
 * @param variant The shape variant of the button
 * @param mainColor The main color
 * @param associatedColor The associated color
 *
 * @return ThemeUIStyleObject
 */
export const computeButtonColors = (
  variant: keyof typeof ButtonVariants,
  mainColor: string,
  associatedColor?: string,
  customStyle?: ThemeUIStyleObject
): ThemeUIStyleObject => {
  let computedStyle: ThemeUIStyleObject = {};

  switch (variant) {
    case 'outline':
      computedStyle = {
        variant: 'buttons.outline',
        color: associatedColor,
        borderColor: mainColor,
        '&:enabled': {
          '&:hover': {
            backgroundColor: `${mainColor}Hover`
          }
        }
      };
      break;
    case 'rounded':
      computedStyle = {
        variant: 'buttons.rounded',
        backgroundColor: mainColor,
        color: associatedColor,
        '&:enabled': {
          '&:hover': {
            backgroundColor: `${mainColor}Hover`
          }
        }
      };
      break;
    case 'text':
      computedStyle = {
        variant: 'buttons.text',
        color: mainColor,
        '&:enabled': {
          '&:hover': {
            color: `${mainColor}Hover`
          }
        }
      };
      break;
    case 'primary':
    default:
      computedStyle = {
        // override shape variant, defined in SchedulingTheme
        variant: 'buttons.primary',
        backgroundColor: mainColor,
        color: associatedColor,
        '&:enabled': {
          '&:hover': {
            backgroundColor: `${mainColor}Hover`
          }
        }
      };
      break;
  }

  return { ...computedStyle, ...customStyle };
};
